import { create } from "zustand";

interface Geo {
  accuracy: string;
  lat: number;
  long: number;
}

interface MapState {
  showMap: boolean;
  setShowMap: (showMap: boolean) => void;
  geoData: Geo[] | null;
  mapBoxApiKey: string | null;
  setMapData: (geoData: Geo[], mapBoxApiKey: string) => void;
}

export const useMapStore = create<MapState>()((set) => ({
  showMap: false,
  setShowMap: (showMap: boolean) => set({ showMap }),
  geoData: null,
  mapBoxApiKey: null,
  setMapData: (geoData: Geo[], mapBoxApiKey: string) =>
    set({ geoData, mapBoxApiKey }),
}));
